// extracted by mini-css-extract-plugin
module.exports = {"shift-rules":"style_shift-rules__B08x-"};